import ApiDealerCrmClient from './clients/ApiDealerCrmClient';
import ApiDealerXClient from './clients/ApiDealerXClient';
import ApiDealerBmsClient from "./clients/ApiDealerBmsClient";
import ApiDealerLegacyBmsClient from "./clients/ApiDealerLegacyBmsClient";
import {onCollectedResponse, clearResponseStack} from "./services/ResponseStack";

export {
    ApiDealerCrmClient,
    ApiDealerXClient,
    ApiDealerBmsClient,
    ApiDealerLegacyBmsClient,
    onCollectedResponse,
    clearResponseStack
}
